<template>
  <v-form
    class="lot-form d-flex flex-column white pa-4 overflow-y-auto" 
    style="border-radius: 15px"
  >
    <block v-if="isLoading"></block>
    <!-- Header -->
    <div class="action-bar d-flex align-center justify-space-between pa-2 rounded-lg">
      <!-- Title -->
      <div 
        class="title p-0 m-0 text-h5"
        style="color: white !important;"
      >
        {{ lotData ? 'Detalles de lote' : 'Crear lote' }}
      </div>
      <!-- Action bar -->
      <div class="d-flex">
        <Button 
          v-if="lotData && $store.getters['rolesUser/getCustomRole'](259) && !refinancing"
          class="mr-2" 
          color="danger" 
          @click="remove"
          prepend-icon="mdi-trash-can"
        >
          Eliminar
        </Button>  
        <!-- <Button class="mr-2" color="warning" @click="restore">
          <div class="d-flex align-center justify-center">
            <v-icon class="mr-1">{{ lotData ? 'mdi-restore' : 'mdi-broom'}}</v-icon>
            <div>{{ lotData ? 'Restaurar' : 'Limpiar'}}</div>
          </div>
        </Button>    
        <Button  color="success" @click="save">
          <div class="d-flex align-center justify-center">
            <v-icon class="mr-1">mdi-content-save</v-icon>
            <div>Guardar</div>
          </div>
        </Button> -->
        <Button 
          v-if="lotData"
          icon="mdi-close"
          color="grey"
          @click="$emit('close')"
         >
         </Button>
      </div>
    </div>
    <!-- Basic info -->
    <div class="basic-info">
      <div class="section-header d-flex align-center justify-space-between py-3">
        <div class="d-flex align-center">
          <v-icon class="mr-1">mdi-note-text</v-icon>
          <h3>Datos generales</h3>
        </div>
        <Button 
          v-if="!lotData"
          color="#3498db"
          prepend-icon="mdi-content-save"
          @click="saveLot"
          dark
        >
          Guardar lote
        </Button>
      </div>
      <v-row class="mt-3">
        <!-- Base service -->
        <v-col cols="12" sm="12" lg="12" xl="4">
          <div class="d-flex">
            <v-autocomplete 
              attach 
              :items="services"
              label="Servicio facturación base" 
              v-model="lotForm.ID_BaseService" 
              :value="lotForm.ID_BaseService"
              item-text="Name"
              item-value="ID_Service"
              prepend-icon="mdi-tools"
              class="mr-2"
              outlined 
              dense
              clearable
              :disabled="!!lotData"
              @input="onFieldInput('ID_BaseService')"
              @blur="onFieldBlur('ID_BaseService')"
              :rules="[v => fieldRequiredRule('ID_BaseService', v)]"
            />
            <Button size="small" style="margin-top: 1px;" :disabled="!!lotData">
              <div class="d-flex align-center justify-center">
                <v-icon class="mr-sm-1">mdi-plus</v-icon>
                <div 
                  class="d-none d-sm-block" 
                  @click="() => {
                    showAddServiceDialog = true;
                    serviceToSet = 'ID_BaseService';
                  }"
                >
                  Añadir servicio
                </div>
              </div>
            </Button>
          </div>
        </v-col>
        <!-- Interest service -->
        <v-col cols="12" sm="12" lg="12" xl="4">
          <div class="d-flex">
            <v-autocomplete 
              attach 
              :items="services"
              label="Servicio facturación interés" 
              v-model="lotForm.ID_InterestService" 
              :value="lotForm.ID_InterestService"
              item-text="Name"
              item-value="ID_Service"
              prepend-icon="mdi-tools"
              class="mr-2"
              outlined 
              dense
              clearable
              :disabled="!!lotData"
              @input="onFieldInput('ID_InterestService')"
              @blur="onFieldBlur('ID_InterestService')"
              :rules="[v => fieldRequiredRule('ID_InterestService', v)]"
            />
            <Button size="small" style="margin-top: 1px;" :disabled="!!lotData">
              <div class="d-flex align-center justify-center">
                <v-icon class="mr-sm-1">mdi-plus</v-icon>
                <div 
                  class="d-none d-sm-block"
                  @click="() => {
                    showAddServiceDialog = true;
                    serviceToSet = 'ID_InterestService';
                  }"
                >
                  Añadir servicio
                </div>
              </div>
            </Button>
          </div>
        </v-col>
        <!-- Lot name -->
        <v-col cols="12" sm="12" lg="6" xl="4">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.LotName"
            label="Nombre del lote"
            prepend-icon="mdi-card-text"
            outlined
            dense
            @input="onFieldInput('LotName')"
            @blur="onFieldBlur('LotName')"
            :rules="[v => fieldRequiredRule('LotName', v)]"
          />
        </v-col>
        <!-- Lot number -->
        <v-col cols="12" sm="6" lg="3" xl="2">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.LotNumber"
            label="Número de lote"
            prepend-icon="mdi-numeric"
            outlined
            dense
            @input="onFieldInput('LotNumber')"
            @blur="onFieldBlur('LotNumber')"
            :rules="[v => fieldRequiredRule('LotNumber', v)]"
          />
        </v-col>
        <!-- Polygon number -->
        <v-col cols="12" sm="6" lg="3" xl="2">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.PolygonNumber"
            label="Número de polígono"
            prepend-icon="mdi-land-plots"
            outlined
            dense
            @input="onFieldInput('PolygonNumber')"
            @blur="onFieldBlur('PolygonNumber')"
            :rules="[v => fieldRequiredRule('PolygonNumber', v)]"
          />
        </v-col>
        <!-- Lot address -->
        <v-col cols="12" sm="12" lg="12" xl="12">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.LotAddress"
            label="Dirección del lote"
            prepend-icon="mdi-map-marker"
            outlined
            dense
            @input="onFieldInput('LotAddress')"
            @blur="onFieldBlur('LotAddress')"
            :rules="[v => fieldRequiredRule('LotAddress', v)]"
          />
        </v-col>
      </v-row>
    </div>
    <!-- Meaurements info -->
    <div class="measurements-info">
      <div class="section-header d-flex align-center py-3">
        <v-icon class="mr-1">mdi-pencil-ruler</v-icon>
        <h3>Medidas</h3>
      </div>
      <v-row class="mt-3">
        <!-- Lot area (in square units) -->
        <v-col cols="12" sm="6" lg="4" xl="3">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.LotArea"
            label="Area del lote"
            prepend-icon="mdi-ruler-square"
            outlined
            dense
          />
        </v-col>
        <!-- Lot dimensions (linear units) -->
        <v-col cols="12" sm="6" lg="4" xl="3">
          <v-text-field
            @focus="$event.target.select()"
            :disabled="!!lotData"
            v-model="lotForm.LotDimensions"
            label="Dimensiones del lote"
            prepend-icon="mdi-ruler"
            outlined
            dense
          />
        </v-col>
      </v-row>
    </div>
    <template v-if="lotData">
      <!-- Sale info -->
      <div class="sales-info">
        <div class="section-header d-flex align-center justify-space-between py-3">
          <div class="d-flex align-center">
            <v-icon class="mr-1">mdi-file-sign</v-icon>
            <h3>Datos de contratación</h3>
          </div>
          <Button 
            v-if="!saleData"
            class="btn-save" 
            prepend-icon="mdi-content-save"
            @click="saveContract"
          >
            Guardar contrato
          </Button>
        </div>
        <v-row class="mt-3">
          <v-col cols="12" sm="6" lg="4" xl="3" class="d-flex">
            <!-- Customer -->
            <v-autocomplete 
              attach 
              :items="customers"
              label="Cliente" 
              v-model="saleForm.customerId" 
              :item-text="(item) => {
                return item.BusinessName || item.BusinessContactName || `${item.FirstName} ${item.LastName}`;
              }"
              item-value="ID_Customer"
              prepend-icon="mdi-account-box"
              outlined 
              dense
              clearable
              :disabled="!!saleData"
              class="mr-1"
            />
            <div v-if="saleForm.customerId" class="d-flex flex-auto align-start justify-center">
              <v-btn 
                icon 
                small 
                @click="openCustomerDetails"
                color="primary"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </div>
          </v-col>
          <!-- Contract Date (DD/MM/YYYY) -->
          <v-col class="position-relative" cols="12" sm="6" lg="4" xl="3">
            <DatePicker
              class="mb-5 mb-sm-0"
              label="Fecha de contratación"
              v-model="saleForm.contractDate"
              @dateSelected="(newValue) => (saleForm.contractDate = newValue)"
              :value="saleForm.contractDate"
              dense
              :disbaled="!!saleData"
            />
          </v-col>
          <v-col cols="12" sm="6" lg="4" xl="3">
            <!-- Seller -->
            <v-autocomplete 
              attach 
              :items="sellers"
              label="Vendedor" 
              v-model="saleForm.sellerId" 
              item-text="FullName"
              item-value="ID_Seller"
              prepend-icon="mdi-account-cash"
              outlined
              :disabled="!!saleData" 
              dense
              clearable
              
            />
          </v-col>
          <v-col cols="12" sm="6" lg="4" xl="3">
            <!-- Seller -->
            <v-autocomplete 
              attach 
              :items="sellers"
              label="Vendedor refereido" 
              v-model="saleForm.referralId" 
              item-text="FullName"
              item-value="ID_Seller"
              prepend-icon="mdi-account-star"
              outlined
              :disabled="!!saleData" 
              dense
              clearable
              
            />
          </v-col>
          <!-- Sale type -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-select
              v-model="saleForm.saleType"
              :items="options.SaleTypes"
              item-text="name"
              item-value="value"
              label="Tipo de Venta"
              prepend-icon="mdi-point-of-sale"
              outlined
              :disabled="!!saleData"
              dense
              
            />
          </v-col>
          <!-- Reservation type -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-select
              v-model="saleForm.reservationType"
              :items="options.ReservationTypes"
              item-text="name"
              item-value="value"
              label="Tipo de reserva"
              prepend-icon="mdi-book"
              outlined
              :disabled="!!saleData"
              dense
              
            />
          </v-col>
          <v-col cols="12" sm="6" lg="4" xl="3">
            <!-- Lot cost -->
            <v-text-field
              @focus="$event.target.select()"
              v-model="saleForm.lotCost"
              label="Costo inicial"
              prepend-icon="mdi-cash-fast"
              type="number"
              outlined
              :disabled="!!saleData"
              dense
              
            />
          </v-col>
          <!-- Sale discount -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <div class="d-flex">
              <!-- Sale discount type -->
              <v-select
                v-model="saleForm.discountType"
                :items="options.DiscountTypes"
                item-text="name"
                item-value="value"
                label="Tipo de descuento"
                prepend-icon="mdi-cart-percent"
                outlined
                :disabled="!!saleData"
                dense
                class="mr-3"
                
              />
              <!-- Sale discount -->
              <v-text-field
                v-if="saleForm.discountType !== enums.DiscountType.NONE"
                @focus="$event.target.select()"
                v-model="saleForm.discount"
                :label="
                  saleForm.discountType === enums.DiscountType.PERCENTAGE 
                    ? `Descuento (%)` 
                    : `Descuento (${currency})`
                "
                type="number"
                outlined
                :disabled="!!saleData"
                dense
              />
            </div>
          </v-col>
          <!-- sale price -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="salePrice"
              label="Precio de venta"
              prepend-icon="mdi-cash-register"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <!-- Initial Paymaent -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="saleForm.initialPayment"
              label="Valor entregado"
              prepend-icon="mdi-cash-check"
              type="number"
              outlined
              :disabled="!!saleData"
              dense
            />
          </v-col>
          <!-- Remaining balance -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="saleBalance"
              label="Balance restante"
              prepend-icon="mdi-cash-clock"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
        </v-row>
      </div>
      <!-- Nuevo Plan de financiamaento -->
      <div v-if="(saleForm.saleType !== enums.SaleType.CASH && !saleData) || refinancing" class="amounts-info">
        <div class="section-header d-flex align-center justify-space-between py-3">
          <div class="d-flex align-center">
            <v-icon class="mr-1">mdi-cash-multiple</v-icon>
            <h3>Nuevo Financiamento</h3>
          </div>
          <Button
            v-if="refinancing"
            size="small"
            color="success"
            prepend-icon="mdi-cash-sync"
            @click="refinance"
          >
            Refinanciar
          </Button>
        </div>
        <v-row class="mt-3">
          <!-- Principal -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="planPrincipal"
              label="Principal"
              prepend-icon="mdi-cash-fast"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <!-- Plan Discount -->
          <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
            <div class="d-flex">
              <!-- Plan discount type -->
              <v-select
                v-model="planForm.discountType"
                :items="options.DiscountTypes"
                item-text="name"
                item-value="value"
                label="Tipo de descuento"
                prepend-icon="mdi-cart-percent"
                outlined
                dense
                class="mr-3"
              />
              <!-- Plan discount -->
              <v-text-field
                v-if="planForm.discountType !== enums.DiscountType.NONE"
                @focus="$event.target.select()"
                v-model="planForm.discount"
                :label="
                  planForm.discountType === enums.DiscountType.PERCENTAGE 
                    ? `Descuento (%)` 
                    : `Descuento (${currency})`
                "
                type="number"
                outlined
                dense
              />
            </div>
          </v-col>
          <!-- Plan initial payment -->
          <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="planForm.initialPayment"
              label="Valor entregado"
              prepend-icon="mdi-cash-check"
              type="number"
              outlined
              dense
            />
          </v-col>
          <!-- Remaining balance -->
          <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="planBalance"
              label="Balance restante"
              prepend-icon="mdi-cash-clock"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <!-- Period type -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <div class="d-flex">
              <v-select
                v-model="planForm.periodType"
                :items="options.FinancingPeriodTypes"
                item-text="name"
                item-value="value"
                label="Tipo de periodo"
                prepend-icon="mdi-calendar-clock"
                outlined
                dense
                class="mr-3"
              />
              <!-- Cantidad de periodos -->
              <v-text-field
                @focus="$event.target.select()"
                v-model="planForm.periods"
                :label="
                  planForm.periodType === enums.FinancingPeriodType.MONTHLY 
                    ? 'Meses de plazo' 
                    : 'Años de plazo'
                "
                type="number"
                outlined
                dense
              />
            </div>
          </v-col>
          <!-- Fecha de primer pago -->
          <v-col class="position-relative" cols="12" sm="6" lg="4" xl="3">
            <DatePicker
              class="mb-5 mb-sm-0"
              label="Fecha de primer pago"
              v-model="planForm.startDate"
              @dateSelected="(newValue) => (planForm.startDate = newValue)"
              :value="planForm.startDate"
              dense
            />
          </v-col>
          <!-- Interest rate -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="planForm.rate"
              label="Tasa de interés"
              prepend-icon="mdi-label-percent"
              type="number"
              outlined
              dense
            />
          </v-col>
          <!-- Total cost -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="totalCost"
              label="Costo total"
              prepend-icon="mdi-cash-register"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <!-- Installment -->
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="installment.total"
              label="Cuota total"
              prepend-icon="mdi-cash-multiple"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="installment.base"
              label="Cuota base"
              prepend-icon="mdi-cash-multiple"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
          <v-col cols="12" sm="6" lg="4" xl="3">
            <v-text-field
              @focus="$event.target.select()"
              v-model="installment.interest"
              label="Cuota interés"
              prepend-icon="mdi-cash-multiple"
              type="number"
              outlined
              dense
              disabled
            />
          </v-col>
        </v-row>
      </div>
      <!-- PLANS -->
      <template v-if="saleData && saleData.plans?.length">
        <div v-for="(plan, idx) in saleData.plans" 
          :key="plan.ID_FinancingPlan"
          class="amounts-info"
        >
          <div 
            class="section-header plan-header d-flex align-center justify-space-between py-3"
            style="cursor: pointer;"
            @click="() => {
              plan.expand = !plan.expand;
              saleData = {...saleData}
            }"
          >
            <div class="d-flex align-center">
              <v-icon class="mr-1">mdi-cash-multiple</v-icon>
              <h3>Financiamento {{ saleData.plans.length - idx }}</h3>
            </div>
            <div
              :style="{
                color: getPlanStatusColor(plan.Status),
                fontWeight: 'bold',
              }" 
            >
              {{ getPlanStatusName(plan.Status) }}
            </div>
            <div>
              <h3 v-if="plan.Status === enums.FinancingPlanStatus.ACTIVE">
                Balance actual: 
                <span 
                  :style="{
                    color: plan.balance.TotalBalance <= 0 
                      ? '#43A047'
                      : '#E57373',
                  }"
                >
                  $ {{ parseFloat(plan.balance.TotalBalance) }}
                </span>
              </h3>
              <h3 v-else>Balance final: $ {{ parseFloat(plan.balance.TotalBalance) }}</h3>
            </div>
          </div>
          <transition
            @before-enter="(el) =>  el.style.height = '0'"
            @enter="(el) => el.style.height = el.scrollHeight + 'px'"
            @before-leave="(el) => el.style.height = el.scrollHeight + 'px'"
            @leave="(el) => el.style.height = '0'"
          >
            <v-row v-show="plan.expand" class="mt-3 pt-3" style="overflow: hidden; transition: height 0.3s ease;">
              <!-- Principal -->
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.principal"
                  label="Principal"
                  prepend-icon="mdi-cash-fast"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <!-- Plan Discount -->
              <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
                <div class="d-flex">
                  <!-- Plan discount type -->
                  <v-select
                    v-model="plan.discountType"
                    :items="options.DiscountTypes"
                    item-text="name"
                    item-value="value"
                    label="Tipo de descuento"
                    prepend-icon="mdi-cart-percent"
                    outlined
                    dense
                    class="mr-3"
                    disabled
                  />
                  <!-- Plan discount -->
                  <v-text-field
                    v-if="plan.discountType !== enums.DiscountType.NONE"
                    @focus="$event.target.select()"
                    v-model="plan.discount"
                    :label="
                      plan.discountType === enums.DiscountType.PERCENTAGE 
                        ? `Descuento (%)` 
                        : `Descuento (${currency})`
                    "
                    type="number"
                    outlined
                    dense
                    disabled
                  />
                </div>
              </v-col>
              <!-- Plan initial payment -->
              <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.initialPayment"
                  label="Valor entregado"
                  prepend-icon="mdi-cash-check"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <!-- Remaining balance -->
              <v-col v-if="saleData?.plans?.length" cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.netAmount"
                  label="Balance restante"
                  prepend-icon="mdi-cash-clock"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <!-- Period type -->
              <v-col cols="12" sm="6" lg="4" xl="3">
                <div class="d-flex">
                  <v-select
                    v-model="plan.periodType"
                    :items="options.FinancingPeriodTypes"
                    item-text="name"
                    item-value="value"
                    label="Tipo de periodo"
                    prepend-icon="mdi-calendar-clock"
                    outlined
                    dense
                    class="mr-3"
                    disabled 
                  />
                  <!-- Cantidad de periodos -->
                  <v-text-field
                    @focus="$event.target.select()"
                    v-model="plan.periods"
                    :label="
                      plan.periodType === enums.FinancingPeriodType.MONTHLY 
                        ? 'Meses de plazo' 
                        : 'Años de plazo'
                    "
                    type="number"
                    outlined
                    dense
                    disabled
                  />
                </div>
              </v-col>
              <!-- Fecha de primer pago -->
              <v-col class="position-relative" cols="12" sm="6" lg="4" xl="3">
                <DatePicker
                  class="mb-5 mb-sm-0"
                  label="Fecha de primer pago"
                  v-model="plan.startDate"
                  @dateSelected="(newValue) => (plan.startDate = newValue)"
                  :value="plan.startDate"
                  dense
                  :disbaled="true" 
                />
              </v-col>
              <!-- Interest rate -->
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.rate"
                  label="Tasa de interés"
                  prepend-icon="mdi-label-percent"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <!-- Total cost -->
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.totalCost"
                  label="Costo total"
                  prepend-icon="mdi-cash-register"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <!-- Installment -->
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.installment.total"
                  label="Cuota total"
                  prepend-icon="mdi-cash-multiple"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.installment.base"
                  label="Cuota base"
                  prepend-icon="mdi-cash-multiple"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-text-field
                  @focus="$event.target.select()"
                  v-model="plan.installment.interest"
                  label="Cuota interés"
                  prepend-icon="mdi-cash-multiple"
                  type="number"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col v-if="plan.endDate" class="position-relative" cols="12" sm="6" lg="4" xl="3">
                <DatePicker
                  class="mb-5 mb-sm-0"
                  label="Fecha de finalización"
                  v-model="plan.endDate"
                  @dateSelected="(newValue) => (plan.endDate = newValue)"
                  :value="plan.endDate"
                  dense
                  :disbaled="true" 
                />
              </v-col>
            </v-row>
          </transition>
        </div>
      </template>
    </template>
    <!-- Comments -->
    <div class="comments-info">
      <div class="section-header d-flex align-center py-3">
        <v-icon class="mr-1">mdi-comment-text</v-icon>
        <h3>Comentarios</h3>
      </div>
      <div>
        <v-textarea
          v-model="lotForm.AdditionalNotes"
          outlined
          rows="7"
          dense
        />
      </div>
    </div>
    <!-- Show add service modal -->
    <v-dialog v-model="showAddServiceDialog" max-width="60%" scrollable>
      <ServiceDetails
        @close="() => showAddServiceDialog = false"
        v-if="showAddServiceDialog"
        @created="reloadAndFindService"
      />
    </v-dialog>
    <alert
      v-model="alert.show"
      :type="alert.type"
      :title="alert.title"
      :message="alert.message"
      @input="alert.onInputEvent"
      @action="alert.onActionEvent"
    />
  </v-form>
</template>

<script>
import Block from '@/components/Block.vue';
import Button from '@/components/Button.vue';
import Alert from '@/components/Alert.vue';
import moment from 'moment';
import DatePicker from "@/components/DatePicker";
import ServiceDetails from '../../ServiceDetails.vue';
import financing from '@/helpers/financing.js';
import enums from '@/helpers/enums.js';
import options from '@/helpers/options.js';

const defaultLot = Object.freeze({
  ID_BaseService: null,
  ID_InterestService: null,
  LotName: '',
  LotAddress: '',
  LotNumber: '',
  PolygonNumber: '',
  LotArea: 0.0,
  LotDimensions: 0.0,
})

const defaultSale = Object.freeze({
  lotId: null,
  customerId: null,
  sellerId: null,
  referralId: null,
  contractDate: moment().format('DD/MM/YYYY'),
  saleType: enums.SaleType.FINANCED,
  reservationType: enums.ReservationType.INITIAL,
  lotCost: 0.0,
  discountType: enums.DiscountType.NONE,
  discount: 0.0,
  initialPayment: 0.0,
  remainingBalance: 0.0,
})

const defaultPlan = Object.freeze({ 
  startDate: moment().format('DD/MM/YYYY'),
  principal: 0.0,
  discountType: enums.DiscountType.NONE,
  discount: 0.0,
  initialPayment: 0.0,
  periodType: enums.FinancingPeriodType.ANNUAL,
  periods: 0,
  rate: 0.0,
  notes: '',
})

export default {
  name: 'RealStateLotForm',
  components: {
    Block,
    Button,
    Alert,
    DatePicker,
    ServiceDetails,
  },
  props: {
    lotData: {
      type: Object,
    },
    refinancing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLoading: false,
      lotForm: { ...defaultLot },
      saleForm: { ...defaultSale },
      planForm: { ...defaultPlan },
      saleData: null,
      services: [],
      serviceToSet: null,
      customers: [],
      sellers: [],
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
      },
      showAddServiceDialog: false,
      formHasBeenSubmitted: false,
      touchedFields: {},
      currency: '$',
      activePlanBalance: null,
    }
  },
  computed: {
    enums () {
      return enums;
    },
    options () {
      return options;
    },
    salePrice () {
      const {
        lotCost,
        discount,
        discountType,
      } = this.saleForm;

      const price = financing.round(
        financing.applyDiscount(financing.parseFloat(lotCost), financing.parseFloat(discount), discountType)
      );

      return price;
    },
    saleBalance () {
      const {
        initialPayment,
      } = this.saleForm;

      const balance = financing.round(financing.parseFloat(this.salePrice) - financing.parseFloat(initialPayment));

      return balance;
    },
    planPrincipal () {
      const currentPlan = this.getCurrentPlan();

      if (!currentPlan) {
        return this.saleBalance;
      }

      return parseFloat(currentPlan.balance.TotalBalance);
    },
    planBalance () {
      const {
        discount,
        discountType,
        initialPayment
      } = this.planForm;

      const net = financing.round(
        financing.applyDiscount(financing.parseFloat(this.planPrincipal), financing.parseFloat(discount), discountType) - financing.parseFloat(initialPayment)
      );

      return net;
    },
    nper () {
      const {
        periods,
        periodType,
      } = this.planForm;

       // Number of periods for period type
      const number = financing.getTotalPeriods(financing.parseInt(periods), periodType);
      
      return number;
    },
    installment () {
      const {
        periodType,
        rate,
      } = this.planForm;

      // Interest for period type
      const periodRate = financing.getPeriodRate(rate, periodType) / 100;

      // Installment amounts (total, base, interest)
      const amounts = financing.calculateInstallment(this.planBalance, this.nper, periodRate); 

      return {
        total: financing.round(amounts.total),
        base: financing.round(amounts.base),
        interest: financing.round(amounts.interest),
      };
    },
    totalCost () {
      const {
        initialPayment,
      } = this.planForm;

      const totalInstallments = financing.round(this.installment.total * this.nper);
      const total = financing.round(financing.parseFloat(initialPayment) + totalInstallments);

      return total;
    },
    financingChanged () {
      return false;
      // return this.saleData && this.saleData.ID_Customer === this.saleForm.customerId 
      //   && (`${this.planForm.principal}` !== `${this.lotData.Principal}`
      //   || `${this.planForm.discountType}` !== `${this.lotData.DiscountType}`
      //   || `${this.planForm.discount}` !== `${this.lotData.Discount}`
      //   || `${this.planForm.initialPayment}` !== `${this.lotData.InitialPayment}`
      //   || `${this.planForm.periodType}` !== `${this.lotData.PeriodType}`
      //   || `${this.planForm.periods}` !== `${this.lotData.Periods}`
      //   || `${this.planForm.rate}` !== `${this.lotData.InterestRate}`);
    }
  },
  methods: {
    restore() {
      this.restoreLotForm();
      this.restoreSaleForm();
      this.restorePlanForm();

      this.formHasBeenSubmitted = false;
      this.touchedFields = {};
      // this.$refs.lotForm?.validate();
    },
    restoreLotForm () {
      if (!this.lotData) {
        this.lotForm = {
          ...defaultLot,
        };
      } else {
        const lotData = this.lotData

        this.lotForm = {
          ID_BaseService: parseInt(lotData.ID_BaseService) || null,
          ID_InterestService: parseInt(lotData.ID_InterestService) || null,
          LotName: `${lotData.LotName || ''}`,
          LotAddress: `${lotData.LotAddress || ''}`,
          LotNumber: `${lotData.LotNumber || ''}`,
          PolygonNumber: `${lotData.PolygonNumber || ''}`,
          LotArea: `${lotData.LotArea || ''}`,
          LotDimensions: `${lotData.LotDimensions || ''}`,
        };

      }
    },
    restoreSaleForm () {
      if (!this.saleData) {
        this.saleForm = {
          ...defaultSale
        };

      } else {
        const saleData = this.saleData

        this.saleForm = {
          ...defaultSale,
          lotId: saleData.ID_RealStateLot,
          saleId: saleData.ID_RealStateLotSale,
          customerId: saleData.ID_Customer || '',
          sellerId: saleData.ID_Seller || '',
          referralId: saleData.ID_Referral || '',
          contractDate: saleData.ContractDate
            ? moment(saleData.ContractDate).format('DD/MM/YYYY')
            : moment().format('DD/MM/YYYY'),
          saleType: saleData.SaleType,
          reservationType: saleData.ReservationType,
          lotCost: parseFloat(saleData.LotCost) || 0.0,
          discountType: saleData.DiscountType,
          discount: parseFloat(saleData.Discount) || 0.0,
          initialPayment: parseFloat(saleData.InitialPayment) || 0.0,
          remainingBalance: parseFloat(saleData.RemainingBalance) || 0.0,
        };
      }
    },
    getCurrentPlan () {
      const plans = this.saleData?.plans;

      if (!plans|| plans.length <= 0) {
        return null;
      }

      const planData = plans.find(p => p.Status === enums.FinancingPlanStatus.ACTIVE); 

      return planData;
    },
    restorePlanForm () {
      const saleData = this.saleData;

      this.planForm = {
        ...defaultPlan
      };
      
      if (saleData && saleData.plans && saleData.plans.length > 0) {
        const plans = saleData.plans;

        plans.forEach(p => {
          p.startDate = this.parseDate(p.StartDate),
          p.endDate = p.EndDate ? this.parseDate(p.EndDate) : null,
          p.discountType = p.DiscountType,
          p.discount = parseFloat(p.Discount) || 0.0,
          p.initialPayment = parseFloat(p.InitialPayment) || 0.0,
          p.periodType = p.PeriodType,
          p.periods = p.Periods || 0.0,
          p.rate = parseFloat(p.InterestRate) || 0.0,
          p.notes = p.Notes || '',
          p.principal = financing.round(financing.parseFloat(p.Principal));
          p.netAmount = financing.round(financing.parseFloat(p.NetAmount));
          p.installment = {
            total: financing.round(parseFloat(p.InstallmentTotal)),
            base: financing.round(parseFloat(p.InstallmentBase)),
            interest: financing.round(parseFloat(p.InstallmentInterest)),
          };
          p.totalCost = financing.round(financing.parseFloat(p.TotalCost));
          p.expand = p.Status === enums.FinancingPlanStatus.ACTIVE;
        })
      }
    },
    async loadServices() {
      try {
        const response = await this.$API.services.getAllServices({ noLimit: true });

        this.services = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de servicios.', 'error');
      }
    },
    async reloadAndFindService(data) {
      await this.loadServices();

      const found = this.services.find(service => service.ID_Service === data.createdServiceId);

      if (found) {
        this.form[this.serviceToSet] = found.ID_Service;
        this.form = {
          ...this.form
        }
      }

      this.serviceToSet = null;
    },
    async loadFinancing() {
      if (!this.lotData) {
        this.saleData = null;
        return
      }

      try {
        const response = await this.$API.realstate.getLotFinancing(this.lotData.ID_RealStateLot);

        if (!response?.data) {
          this.saleData = null;
          this.plans = null;
          return
        }

        const { data: resData } = response;

        this.saleData = resData;
      } catch(err) {
        console.log('El lote no tiene datos de venta, o ha ocurrido un error y no se pudieron obtener.');
      }
    },
    async loadCustomers() {
      try {
        const business = JSON.parse(localStorage.getItem("user")).businessid || ""
        const branch = JSON.parse(localStorage.getItem("user")).branch || ""

        const response = await this.$API.customers.getCustomers({
          business,
          branch
        })

        this.customers = response;
        
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de clientes.', 'error');
      }
    },
    async loadSellers() {
      try {
        const response = await this.$API.sellers.getAllSellersFiltered();

        this.sellers = response;
      } catch(err) {
        this.showAlert('Error', 'Ha ocurrido obteniendo la lista de vendedores.', 'error');
      }
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
    openCustomerDetails() {
      const selectedCustomer = this.customers.find(c => c.ID_Customer === this.saleForm.customerId);
      if (selectedCustomer) {
        this.$store.commit('customerData/changeView', 'tab-1'); 
        this.$store.dispatch('addWindow', {
          'name': 'customerData',
          component: 'CustomerData',
          unique: false,
          meta: { customerToShow: selectedCustomer }
        });
        this.$emit('close');
      }
    },
    onFieldInput() {
      // Mark field as touched when cleared or changed (especially if cleared)
      // if (!this.form[field]) {
      //   this.$set(this.touchedFields, field, true);
      // }
    },
    onFieldBlur(field) {
      // Mark field as touched to start showing errors if invalid
      this.$set(this.touchedFields, field, true);
    },
    fieldRequiredRule(fieldName, v) {
      if (!this.formHasBeenSubmitted && !this.touchedFields[fieldName]) {
        // don't show error initially
        return true;
      }

      return !!v || 'Este campo es obligatorio.';
    },
    parseDate(dateString) {
      const date = moment(dateString).utcOffset(6000)

      if (!date.isValid()) {
        console.log(`Fecha inválida: ${dateString}`)
      }

      return date.isValid
          ? moment(dateString).format('DD/MM/YYYY')
          : moment().format('DD/MM/YYYY')
    },
    getPlanStatusName(planStatus) {
      switch (planStatus) {
        case enums.FinancingPlanStatus.INACTIVE:
          return 'ACTIVO';
        case enums.FinancingPlanStatus.ACTIVE:
          return 'ACTIVO';
        case enums.FinancingPlanStatus.PAID:
          return 'PAGADO';
        case enums.FinancingPlanStatus.REFINANCED:
          return 'REFINANCIADO';
        case enums.FinancingPlanStatus.CANCELLED:
          return 'CANCELADO';
        default:
          return '';
      }
    },
    getPlanStatusColor(planStatus) {
      switch (planStatus) {
        case enums.FinancingPlanStatus.INACTIVE:
          return '#0000008a';
        case enums.FinancingPlanStatus.ACTIVE:
          return '#00695C';
        case enums.FinancingPlanStatus.PAID:
          return '#2E7D32';
        case enums.FinancingPlanStatus.REFINANCED:
          //return '#4527A0';
          return '#0000008a';
        case enums.FinancingPlanStatus.CANCELLED:
          return '#0000008a';
        default:
          return '';
      }
    },
    async save() {
      this.isLoading = true;
      // try {
      //   this.formHasBeenSubmitted = true;
      //   // const valid = this.$refs.lotForm?.validate();

      //   // if (!valid) {
      //   //   this.showAlert('Advertencia', 'Por favor rellene todos los campos requeridos.', 'warning');
      //   //   this.isLoading = false;
      //   //   return;
      //   // }

      //   let response = null;

      //   if (this.lotData) {
      //     const updateData = {
      //       ID_Customer: this.form.ID_Customer || null,
      //       ContractDate: this.form.ContractDate,
      //       FirstPaymentDate: this.form.FirstPaymentDate,
      //       ID_Seller: this.form.ID_Seller || null,
      //       ID_Referral: this.form.ID_Referral || null,
      //       SaleType: `${this.form.SaleType || ''}`,
      //       ReservationType: `${this.form.ReservationType || ''}`,
      //       UpfrontPrice: parseFloat(this.form.UpfrontPrice),
      //       DiscountType: `${this.form.DiscountType || 'none'}`,
      //       Discount: parseFloat(this.form.Discount) || 0.0,
      //       AmountPaid: parseFloat(this.form.AmountPaid),
      //       PeriodType: `${this.form.DiscountType || 'annual'}`,
      //       Periods: parseInt(this.form.Periods) || 0,
      //       InterestRate: parseFloat(this.form.InterestRate),
      //       TotalCost: parseFloat(this.totalLotCost),
      //       MonthlyPayment: parseFloat(this.installmentValue),
      //       MonthlyBasePayment: parseFloat(this.installmentBase),
      //       MonthlyInterestPayment: parseFloat(this.installmentInterest),
      //       AdditionalNotes: `${this.form.AdditionalNotes || ''}`,
      //     };

      //     // Call update endpoint
      //     response = await this.$API.realstate.updateLot({
      //       where: {
      //         ID_RealStateLot: this.lotData?.ID_RealStateLot,
      //         ID_Business: this.lotData?.ID_Business, 
      //         ID_Branch: this.lotData?.ID_Branch, 
      //       }, 
      //       data: updateData,
      //     })
      //     this.showAlert(
      //       'Lote actualizado', 
      //       'El lote se ha actualizado exitosamente.', 
      //       'success',
      //       () => {
      //         this.closeAlert();
      //         this.$emit('lot-updated');
      //       }
      //     );
      //   } else {
      //     const ID_Business = JSON.parse(localStorage.getItem("user")).businessid || "";
      //     const ID_Branch = JSON.parse(localStorage.getItem("user")).branch || "";

      //     const createData = {
      //       ...this.form,
      //       UpfrontPrice: parseFloat(this.form.UpfrontPrice),
      //       DiscountType: `${this.form.DiscountType || 'none'}`,
      //       Discount: parseFloat(this.form.Discount) || 0.0,
      //       AmountPaid: parseFloat(this.form.AmountPaid),
      //       PeriodType: `${this.form.DiscountType || 'annual'}`,
      //       Periods: parseInt(this.form.Discount) || 0,
      //       InterestRate: parseFloat(this.form.InterestRate),
      //       TotalCost: parseFloat(this.totalLotCost),
      //       MonthlyPayment: parseFloat(this.installmentValue),
      //       MonthlyBasePayment: parseFloat(this.installmentBase),
      //       MonthlyInterestPayment: parseFloat(this.installmentInterest),
      //       ID_Business,
      //       ID_Branch,
      //     };

      //     // Call create endpoint
      //     response = await this.$API.realstate.addLot({ data: createData})
      //     this.showAlert(
      //       'Lote guardado', 
      //       'El lote se ha agregado exitosamente.', 
      //       'success',
      //       () => {
      //         this.closeAlert();
      //         this.$emit('lot-created');
      //       }
      //     );
      //     this.restore();
      //   }

      //   console.log(response)
      // } catch(err) {
      //   console.log(err);
      //   this.showAlert('Error', 'Ha ocurrido agregando el lote.', 'error');
      // }
      this.isLoading = false;
    },
    async saveLot() {
      this.isLoading = true;
      try {
        this.formHasBeenSubmitted = true;
        // const valid = this.$refs.lotForm?.validate();

        // if (!valid) {
        //   this.showAlert('Advertencia', 'Por favor rellene todos los campos requeridos.', 'warning');
        //   this.isLoading = false;
        //   return;
        // }

        let response = null;

        const ID_Business = JSON.parse(localStorage.getItem("user")).businessid || "";
        const ID_Branch = JSON.parse(localStorage.getItem("user")).branch || "";

        const createData = {
          ...this.lotForm,
          ID_Business,
          ID_Branch,
        };

        // Call create endpoint
        response = await this.$API.realstate.addLot({ data: createData})

        console.log(response)
        
        this.showAlert(
          'Lote guardado', 
          'El lote se ha agregado exitosamente.', 
          'success',
          () => {
            this.closeAlert();
            this.$emit('lot-created');
          }
        );

        this.restore();

        console.log(response)
      } catch(err) {
        console.log(err);
        this.showAlert('Error', 'Ha ocurrido un error agregando el lote.', 'error');
      }
      this.isLoading = false;
    },
    async refinance() {
      this.isLoading = true;
      try {
        this.formHasBeenSubmitted = true;

        let response = null;

        const newPlan = {
          principal: parseFloat(this.planForm.principal),
          discountType: this.planForm.discountType,
          discount: parseFloat(this.planForm.discount),
          periodType: this.planForm.periodType,
          periods: financing.parseInt(this.planForm.periods),
          initialPayment: financing.parseInt(this.planForm.initialPayment),
          startDate: this.planForm.startDate,
          rate: financing.parseFloat(this.planForm.rate),
        };

        // Call create endpoint
        response = await this.$API.realstate.refinanceLot(
          { 
            data: {
              saleId: this.saleData.ID_RealStateLotSale, 
              newPlan,
            } 
          }
        );

        console.log(response)
        
        this.showAlert(
          'Lote refinanciado', 
          'El lote se ha refinanciado exitosamente.', 
          'success',
          () => {
            this.closeAlert();
            this.$emit('lot-refinanced');
          }
        );

        this.restore();

        console.log(response)
      } catch(err) {
        console.log(err);
        this.showAlert('Error', 'Ha ocurrido un error refinanciando el lote.', 'error');
      }
      this.isLoading = false;
    },
    async saveContract() {
      this.isLoading = true;

      try {
        let response = null;

        const newContractData = {
          // sale data
          lotId: this.lotData.ID_RealStateLot,
          customerId: this.saleForm.customerId,
          sellerId: this.saleForm.sellerId,
          referralId: this.saleForm.referralId,
          contractDate: this.saleForm.contractDate,
          saleType: this.saleForm.saleType,
          reservationType: this.saleForm.reservationType,
          lotCost: financing.parseFloat(this.saleForm.lotCost),
          discountType: this.saleForm.discountType,
          discount: financing.parseFloat(this.saleForm.discount),
          initialPayment: financing.parseFloat(this.saleForm.initialPayment),
          // plan data
          principal: this.planForm.principal,
          periodType: this.planForm.periodType,
          periods: financing.parseInt(this.planForm.periods),
          startDate: this.planForm.startDate,
          rate: financing.parseFloat(this.planForm.rate),
        };

        response = await this.$API.realstate.addLotSale({ data: newContractData })

        this.showAlert(
          'Contrato creado', 
          'El contrato se ha creado exitosamente.', 
          'success',
          () => {
            this.closeAlert();
            this.$emit('lot-updated');
          }
        );

        console.log(response)
      } catch(err) {
        console.log(err);
        this.showAlert('Error', 'Ha ocurrido creando el contrato.', 'error');
      }

      this.isLoading = false;
    },
    async remove() {
      this.isLoading = true;

      try {
        const ID_Business = JSON.parse(localStorage.getItem("user")).businessid || "";
        const ID_Branch = JSON.parse(localStorage.getItem("user")).branch || "";

        // Call update endpoint
        await this.$API.realstate.deleteLot({
          where: {
            ID_RealStateLot: this.lotData.ID_RealStateLot,
            ID_Business, 
            ID_Branch, 
          },
        });

        console.log('lot updated')

        this.showAlert(
          'Lote eliminado', 
          'El lote se ha eliminado.', 
          'success',
          () => {
            this.closeAlert();
            this.$emit('lot-deleted');
          }
        );
      } catch (err) {
        console.log(err);
        this.showAlert('Error', 'Ha ocurrido eliminando el lote.', 'error');
      }
      
      this.isLoading = false;
    },
  },
  async mounted() {
    this.currency = JSON.parse(localStorage.getItem("branch")).Currency;
    
    this.isLoading = true;
    await Promise.all([
      this.loadServices(),
      this.loadCustomers(),
      this.loadSellers(),
      this.loadFinancing(),
    ]);
    this.isLoading = false;
    
    this.restore();
  }
}
</script>

<style scoped>
.section-header {
  border-top: 1px solid #E0E0E0;
  margin: 2rem 0 1rem 0;
}

.section-header h3 {
  color: #0000008a !important;
}

.plan-header:hover {
  background-color: #E8F5E9;
} 

.action-bar {
  background-color: #616161;
}
</style>